import React, { Component } from 'react';
import { connect } from 'react-redux';
import { _LIST_PAGINATION_MODEL } from '../../../store/modules/app/models';
import { recommendSearchWordActions } from '../../../store/modules/recommend/searchWord';
import {
  RECOMMEND_SEARCH_WORD_LIST_SEARCH_DATA_MODEL,
  RECOMMEND_SEARCH_WORD_LIST_SEARCH_OPTION_MODEL,
} from '../../../store/modules/recommend/searchWord/models';
import RecommendSearchWordListWrap from '../../../views/recommend/searchWord/list/RecommendSearchWordListWrap';

class RecommendSearchWordListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = () => {
    const { setData } = this.props;

    this.getList({
      /**
       *  검색 옵션
       */
      searchOption: RECOMMEND_SEARCH_WORD_LIST_SEARCH_OPTION_MODEL,
      /**
       *  pagination
       */
      pagination: _LIST_PAGINATION_MODEL,
    });

    /**
     * 검색 박스 초기화
     */
    setData({
      path: ['recommendSearchWordList', 'searchData'],
      value: RECOMMEND_SEARCH_WORD_LIST_SEARCH_DATA_MODEL,
    });
  };

  /**
   * 리스트 불러오기
   */
  getList = async (data) => {
    const { getRecommendSearchWordList, recommendSearchWordList } = this.props;
    const { searchOption, sortOption, pagination } = recommendSearchWordList;

    getRecommendSearchWordList({
      searchOption,
      sortOption,
      pagination,
      ...data,
    });
  };

  render() {
    const { recommendSearchWordList, setData } = this.props;

    return (
      <RecommendSearchWordListWrap
        recommendSearchWordList={recommendSearchWordList}
        setData={setData}
        getList={this.getList}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    recommendSearchWordList: state.recommendSearchWord.recommendSearchWordList,
  };
};

const mapDispatchToProps = {
  setData: recommendSearchWordActions.setData,
  getRecommendSearchWordList: recommendSearchWordActions.getRecommendSearchWordList,
};

export default connect(mapStateToProps, mapDispatchToProps)(RecommendSearchWordListContainer);
